const FLAGS = [
	{ name: 'Consumables', key: 'consumables' },
	{ name: 'App Settings', key: 'appSettings' },
	{ name: 'Map', key: 'map' },
	{ name: 'iPad', key: 'iPadView' },
	{ name: 'Insights', key: 'insights' },
	{ name: 'Service Notifications', key: 'serviceNotifications' },
];

const useFlags = (user) => {
	return {
		all: FLAGS,
		check: (flag) => {},
	};
};

export default useFlags;
